import {
  mapKeys,
  omit,
} from 'lodash';

import { camelToSnakeCase } from './index';

export const checkActionFileSupport = (action, file) => {
  if (action.no_file && !action.actionbar) return { isSupported: false, message: '' };

  if (action.file_types) {
    if (!(
      action.file_types.includes(file.type_group) ||
      action.file_types.includes(file.type)
    )) {
      return {
        isSupported: false,
        message: 'This file type is not supported',
      };
    }
  }

  const failedConstraint = (action.file_constraints || []).reduce((failed, constraint) => {
    if (failed) return failed;

    switch (constraint.type) {
      case 'megapixels': {
        if (!file.attributes?.width || !file.attributes?.height) {
          return { isSupported: false, message: 'This file type is not supported' };
        }

        const megapixels = (file.attributes.width * file.attributes.height) / 1_000_000;

        if (constraint.limit === 'max' && megapixels > constraint.value) {
          return {
            isSupported: false,
            message: constraint.message,
            actionbarMessage: constraint.actionbar_message,
          };
        }

        if (constraint.limit === 'min' && megapixels < constraint.value) {
          return {
            isSupported: false,
            message: constraint.message,
            actionbarMessage: constraint.actionbar_message,
          };
        }

        return null;
      }

      default:
        return null;
    }
  }, null);

  if (failedConstraint) {
    return failedConstraint;
  }

  return { isSupported: true };
};

export const getCustomConfigFields = (config) => (
  mapKeys(omit(config, [
    'id',
    'integrationId',
    'actions',
    'authentication_url',
    'authToken',
    'theme',
    'theme_logo',
    'name',
  ]), (v, k) => (camelToSnakeCase(k)))
);

export const getOriginalUrlParams = (params) => {
  const p = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    p.append(key, params[key]);
  });
  return p.toString();
};

export const sendPostMessage = (event, data) => {
  if (window.sp.miniConfig.eventTarget) {
    window.sp.miniConfig.eventTarget.postMessage({
      source: 'spmini',
      event,
      data,
    }, '*');
  }
};

export const findAction = (actions, id) => actions.find(a => a.id === id);
